import React from 'react';
import { get, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm, Text, TextArea, validator, Select } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { css, cx } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';

const styles = css`
  label {
    font-weight: 800;
    font-size: 18px;
    color: #686868;
    .required {
      color: #8F2329;
    }
  }
  .form-row {
    margin: 0 0 45px 0;
    .col {
      padding: 0 30px 0 0;
    }
  }
  input, select, textarea {
    border-radius: 0;
    border-color: #DCD7C7;
  }
  @media (max-width: 767.98px) {
    .col + .col {
      margin-top: 45px;
    }
    .form-control {
      min-width: 320px;
    }
    label {
      display: block;
      text-align: left;
    }
  }
`;

function validate(values) {
  const response = {
    firstName: null,
    lastName: null,
    email: null,
  };

  if (!values.firstName) {
    response.firstName = {
      error: 'First Name is required',
    };
  }

  if (!values.lastName) {
    response.lastName = {
      error: 'Last Name is required',
    };
  }

  if (!values.email) {
    response.email = {
      error: 'Email is required',
    };
  } else if (!validator.isEmail(values.email)) {
    response.email = {
      error: 'Email must be valid',
    };
  }

  return response;
}

class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    const { formApi } = props;

    formApi.setValue('formName', 'contactUs');
    formApi.setValue('formLabel', 'Contact Us');

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  render() {
    const { areas, communities, className, formApi, success, noRedirect } = this.props;

    function getError(field) {
      return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
    }

    function getErrorClass(field) {
      if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
        return 'ContactForm_invalid is-invalid';
      }

      return null;
    }

    if (success) {
      return (
        <div>
          {
            !noRedirect &&
            <Redirect
              name="contact-us-thank-you"
            />
          }
          {
            noRedirect &&
            <div style={{ color: '#FFFFFF' }}>
              <h4>Thank You</h4>
              <p>
                For contacting us. We have recieved your message and will respond as soon as {' '}
                possible.
              </p>
            </div>
          }
        </div>
      );
    }

    return (
      <div className={cx('pb-5', styles, className)}>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CF_firstName">First Name <span className="required">*</span></label>
            <Text
              id="CF_firstName"
              field="firstName"
              name="firstName"
              className={`form-control ${getErrorClass('firstName')}`}
              placeholder="First Name *"
            />
            <div className="invalid-feedback">
              {getError('firstName')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="CF_lastName">Last Name <span className="required">*</span></label>
            <Text
              id="CF_lastName"
              field="lastName"
              name="lastName"
              className={`form-control ${getErrorClass('lastName')}`}
              placeholder="Last Name *"
            />
            <div className="invalid-feedback">
              {getError('lastName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CF_email">Email <span className="required">*</span></label>
            <Text
              id="CF_email"
              field="email"
              name="email"
              className={`form-control ${getErrorClass('email')}`}
              placeholder="Email Address *"
            />
            <div className="invalid-feedback">
              {getError('email')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="CF_phone">Phone <span className="required">*</span></label>
            <Text
              id="CF_phone"
              field="phone"
              name="phone"
              className={`form-control ${getErrorClass('phone')}`}
              placeholder="Phone *"
            />
            <div className="invalid-feedback">
              {getError('phone')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CF_hearAboutUs">How Did You Hear About Us?</label>
            <Select
              id="CF_hearAboutUs"
              className={`form-control ${getErrorClass('hearAboutUs')}`}
              name="hearAboutUs"
              field="hearAboutUs"
              placeholder="Make A Selection"
              options={[
                { label: '2 Find Your Home', value: '2 Find Your Home' },
                { label: 'Social Media', value: 'Social Media' },
                { label: 'Internet Search', value: 'Internet Search' },
                { label: 'Signage', value: 'Signage' },
                { label: 'Zillow & Trulia', value: 'Zillow & Trulia' },
                { label: 'Referral', value: 'Referral' },
                { label: 'Realtor', value: 'Realtor' },
                { label: 'Other', value: 'Other' },
              ]}
            />
            <div className="invalid-feedback">
              {getError('hearAboutUs')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="CF_priceRange">What Is Your Price Range?</label>
            <Select
              id="CF_priceRange"
              className={`form-control ${getErrorClass('priceRange')}`}
              name="priceRange"
              field="priceRange"
              placeholder="Make A Selection"
              options={[
                { label: '$250,000-$350,000', value: '$250,000-$350,000' },
                { label: '$350,000-$450,000', value: '$350,000-$450,000' },
                { label: '$450,000-$550,000', value: '$450,000-$550,000' },
                { label: '$550,000-higher', value: '$550,000-higher' },
              ]}
            />
            <div className="invalid-feedback">
              {getError('priceRange')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CF_city">City Of Interest</label>
            <Select
              id="CF_city"
              className={`form-control ${getErrorClass('city')}`}
              name="Area"
              field="Area"
              placeholder="Make A Selection"
              options={orderBy(areas, 'name', 'asc').map(area => ({ label: get(area, 'name'), value: get(area, 'name') }))}
            />
            <div className="invalid-feedback">
              {getError('Area')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="CF_com">Community Of Interest?</label>
            <Select
              id="CF_com"
              className={`form-control ${getErrorClass('com')}`}
              name="com"
              field="com"
              placeholder="Make A Selection"
              options={orderBy(communities, 'name', 'asc').map(community => ({ label: get(community, 'name'), value: get(community, '_id') }))}
            />
            <div className="invalid-feedback">
              {getError('com')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CF_comments">Comments</label>
            <TextArea
              id="CF_comments"
              field="comments"
              name="comments"
              className={`form-control ${getErrorClass('comments')}`}
              placeholder="How can our Online Sales Advisors help you?"
              rows="4"
            />
            <div className="invalid-feedback">
              {getError('comments')}
            </div>
          </div>
        </div>
        <button type="submit" className="btn">Send</button>
      </div>
    );
  }
}

ContactForm.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  formApi: PropTypes.object.isRequired,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  noRedirect: PropTypes.bool,
};

ContactForm.defaultProps = {
  className: undefined,
  success: undefined,
  onSuccess: () => {},
  noRedirect: false,
};

export default lassoForm({
  validate,
})(
  withData(
    {
      communities: true,
      areas: true,
    },
  )(ContactForm),
);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContactForm.js